import React from 'react';
import { ErrorStateProps } from './types';
import { InfoState, InfoStateProps } from '@xingternal/pages-common';
import errorIcon from './assets/error.svg';
import styles from './styles.css';

const ErrorState: React.FunctionComponent<ErrorStateProps & InfoStateProps> = ({
  onReloadClick,
  buttonProps,
  ...props
}) => (
  <InfoState
    className={styles.errorState}
    icon={errorIcon}
    headlineCopyKey="EP_ERROR"
    buttonProps={{
      copyKey: 'EP_ERROR_RELOAD_CTA',
      onClick: onReloadClick,
      variant: 'tertiary',
      ...buttonProps,
    }}
    {...props}
  />
);

export default ErrorState;
